"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var DialogService_1 = require("../Dialog/service/DialogService");
var ButtonProps_1 = require("../Button/ButtonProps");
var DialogProps_1 = require("../Dialog/DialogProps");
require("./CustomErrMsgDialog.css");
var Dialog_1 = require("../Dialog");
var CustomErrMsgDialog = /** @class */ (function (_super) {
    __extends(CustomErrMsgDialog, _super);
    /* Constructor & Life-Cycle Methods */
    function CustomErrMsgDialog(props) {
        var _this = _super.call(this, props) || this;
        _this.bindAll();
        return _this;
    }
    CustomErrMsgDialog.prototype.componentDidMount = function () {
        // if this component is used from node_modules, then a reference to dialogService must be passed in
        this.dialog = this.props.dialogServiceRef || DialogService_1.default.getInstance();
        // construct initial error entry from props
        var initialErrorEntry = this.constructErrEntryFromProps(this.props);
        // if cmsErrorCode passed in, match error entry against passed in cmsErrorCodes and adjust error entry model
        var adjustedErrorEntry = (this.cmsErrorCodesExist) ?
            this.adjustErrEntryIfCmsMatch(initialErrorEntry, this.props.data.cmsErrorCodes) : initialErrorEntry;
        // construct modal options
        var modalOptions = this.optionPropsExist ?
            this.constructModalOptions(adjustedErrorEntry, this.props.options) :
            this.constructModalOptions(adjustedErrorEntry);
        // open error dialog with passed in options
        this.showCustomErrDialog(modalOptions);
    };
    CustomErrMsgDialog.prototype.bindAll = function () {
        this.showCustomErrDialog = this.showCustomErrDialog.bind(this);
        this.closeCTA = this.closeCTA.bind(this);
        this.cancelCTA = this.cancelCTA.bind(this);
        this.okCTA = this.okCTA.bind(this);
        this.constructActionBtns = this.constructActionBtns.bind(this);
    };
    Object.defineProperty(CustomErrMsgDialog.prototype, "optionPropsExist", {
        /* Getters */
        get: function () { return !!this.props.options; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CustomErrMsgDialog.prototype, "customErrorMsgExists", {
        get: function () { return !!(this.props.options && this.props.options.customErrorMsg); },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CustomErrMsgDialog.prototype, "apiNameExists", {
        get: function () {
            return !!(this.props.data && this.props.data.apiError && this.props.data.apiError.apiName);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CustomErrMsgDialog.prototype, "apiErrorExists", {
        get: function () { return !!(this.props.data && this.props.data.apiError); },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CustomErrMsgDialog.prototype, "apiErrorCodeExists", {
        get: function () {
            return !!(this.props.data && this.props.data.apiError && this.props.data.apiError.errorCode);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CustomErrMsgDialog.prototype, "cmsErrorCodesExist", {
        get: function () { return !!(this.props.data && this.props.data.cmsErrorCodes); },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CustomErrMsgDialog.prototype, "closeCtaExists", {
        get: function () { return !!(this.props.events && this.props.events.closeCTA); },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CustomErrMsgDialog.prototype, "cancelCtaExists", {
        get: function () { return !!(this.props.events && this.props.events.cancelCTA); },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CustomErrMsgDialog.prototype, "okCtaExists", {
        get: function () { return !!(this.props.events && this.props.events.okCTA); },
        enumerable: false,
        configurable: true
    });
    /* Construct Modal Methods */
    CustomErrMsgDialog.prototype.constructErrEntryFromProps = function (props) {
        if (this.apiErrorExists) {
            return {
                apiName: this.apiNameExists ? this.props.data.apiError.apiName : '',
                errorCode: this.apiErrorCodeExists ? this.props.data.apiError.errorCode : '',
                errorMsg: (this.customErrorMsgExists ?
                    this.props.options.customErrorMsg : this.props.data.apiError.errorMsg) || '',
            };
        }
        else {
            return {
                apiName: '',
                errorCode: '',
                errorMsg: '',
            };
        }
    };
    CustomErrMsgDialog.prototype.adjustErrEntryIfCmsMatch = function (errorEntry, cmsErrorCodes) {
        if (errorEntry.errorCode && errorEntry.apiName) {
            // First, filter by error code
            var filteredByErrCode = cmsErrorCodes.filter(function (error) {
                return error.errorCode === errorEntry.errorCode;
            });
            // If cmsMatch, return cms error entry. Otherwise return passed-in error entry
            return (filteredByErrCode.length > 0) ? filteredByErrCode[0] : errorEntry;
        }
        return errorEntry;
    };
    CustomErrMsgDialog.prototype.constructModalOptions = function (errorEntry, options) {
        var defaultErrMsg = 'There was an error';
        // use error message from cms match if found, then custom if available and then fall back to default
        var errMsg = errorEntry.errorMsg;
        if (!errMsg) {
            errMsg = (options && options.customErrorMsg) ? options.customErrorMsg : defaultErrMsg;
        }
        var apiName = errorEntry.apiName ? "(API: " + errorEntry.apiName + ") - " : '';
        var defaultModalTitle = 'Error!';
        var modalTitle = (options && options.modalTitle) ? options.modalTitle : defaultModalTitle;
        return {
            actions: options ? this.constructActionBtns(options) : this.constructActionBtns(),
            message: apiName + " " + errMsg,
            title: "" + modalTitle,
        };
    };
    CustomErrMsgDialog.prototype.showCustomErrDialog = function (modalOptions) {
        var _this = this;
        this.dialog.show({
            actions: modalOptions.actions,
            message: modalOptions.message,
            onCancel: function () { return _this.cancelCTA(); },
            showClose: true,
            title: modalOptions.title,
            type: DialogProps_1.DialogTypes.ERROR,
        });
    };
    CustomErrMsgDialog.prototype.constructActionBtns = function (optionProps) {
        // default button text if option props are not passed in
        var defaultOkBtnName = (optionProps && optionProps.showCancelBtn) ? 'Ok' : 'Close';
        var defaultCancelBtnName = 'Cancel';
        // assign proper text to modal buttons
        var okBtnName = (optionProps && optionProps.okBtnText) ? optionProps.okBtnText : defaultOkBtnName;
        var cancelBtnName = (optionProps && optionProps.cancelBtnText) ?
            optionProps.cancelBtnText : defaultCancelBtnName;
        // return array of required buttons
        var actionBtns = [Dialog_1.default.Action(okBtnName, this.okCTA, ButtonProps_1.ButtonType.PRIMARY)];
        if (optionProps && optionProps.showCancelBtn) {
            actionBtns.push(Dialog_1.default.Action(cancelBtnName, this.cancelCTA, ButtonProps_1.ButtonType.GHOST));
        }
        return actionBtns;
    };
    /* Modal Events Methods */
    CustomErrMsgDialog.prototype.closeCTA = function () {
        if (this.closeCtaExists) {
            this.props.events.closeCTA();
        }
    };
    CustomErrMsgDialog.prototype.cancelCTA = function () {
        if (this.cancelCtaExists) {
            this.props.events.cancelCTA();
        }
    };
    CustomErrMsgDialog.prototype.okCTA = function () {
        if (this.okCtaExists) {
            this.props.events.okCTA();
        }
    };
    /* Render */
    CustomErrMsgDialog.prototype.render = function () { return true; };
    CustomErrMsgDialog.defaultProps = {
        apiName: '',
        errorCode: '',
        errorMsg: '',
        httpCode: 0,
    };
    return CustomErrMsgDialog;
}(React.Component));
exports.default = CustomErrMsgDialog;
//# sourceMappingURL=CustomErrMsgDialog.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/atoms/CustomErrMsgDialog/CustomErrMsgDialog.js
// module id = 937
// module chunks = 8